const techData =[
    {
      id: 1,
      stackName: "Angular",
      stackImage: "./techStack/angular.png",
    },
    {
      id: 2,
      stackName: "React",
      stackImage: "./techStack/react.png",
    },
    {
      id: 3,
      stackName: "Selenium",
      stackImage: "./techStack/selenium.png",
    },
    {
      id: 4,
      stackName: "Maven",
      stackImage: "./techStack/maven.svg",
    },
    {
      id: 5,
      stackName: "Java",
      stackImage: "./techStack/java.png",
    },
    {
      id: 6,
      stackName: "Spring",
      stackImage: "./techStack/spring.png",
    },
    {
      id: 7,
      stackName: "Vs Code",
      stackImage: "./techStack/vscode.png",
    },
    {
      id: 8,
      stackName: "InteliJ",
      stackImage: "./techStack/intelij.png",
    },
    {
      id: 9,
      stackName: "Python",
      stackImage: "./techStack/python.png",
    },
  ];

  export default techData;